var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-radio-group',{attrs:{"size":"mini"},on:{"change":_vm.change},model:{value:(_vm.x),callback:function ($$v) {_vm.x=$$v},expression:"x"}},_vm._l((_vm.xfields),function(x){return _c('el-radio-button',{key:x.name,attrs:{"label":x.name}},[_vm._v(_vm._s(x.title))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b01b6e7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/presentation/chart/xfield.vue
// module id = null
// module chunks = 